import { RESET } from './ResetPasswordConstants'

export const reset = () => {
  const action = {
    type: RESET,
  }
  return action
}
